<template>
  <v-container>
    <div>
      <v-alert
        :type="alertType"
        transition="scale-transition"
        v-model="alertShow"
        border="left"
        dismissible
      >
        <pre class="body-1">{{ alertMsg }}</pre>
      </v-alert>
    </div>
    <v-card>
      <v-list>
        <v-list-group no-action sub-group :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DataHome.devices.infos")
              }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title
                class="mb-3"
                v-text="device.name"
              ></v-list-item-title>

              <v-list-item-subtitle
                v-html="'ID : ' + device.id"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-html="'NetworkID : ' + device.networkId"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-html="'Network : ' + device.network"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-html="'DeviceTypeID : ' + device.deviceTypeId"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-html="'DeviceType : ' + device.deviceType"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DataHome.devices.deviceTypeProperty")
              }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item>
            <v-list-item-content>
              <template v-if="propertyloading">
                <div class="text-center mb-5">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
              </template>
              <template v-else>
                <v-container>
                  <v-row align="center">
                    <v-col v-if="properties.length == 0" cols="11">
                      <v-alert type="info">{{
                        $t("DataHome.noProperty")
                      }}</v-alert>
                    </v-col>
                    <v-col
                      v-for="(prop, index) in properties"
                      :key="index"
                      cols="12"
                      sm="7"
                    >
                      <div
                        class="text-subtitle-2 mb-2"
                        v-text="prop.property"
                        :key="prop.property"
                      ></div>
                      <template v-if="prop.type == 'object'">
                        <v-card :elevation="2" class="pa-3">
                          <v-row align="center">
                            <v-col>
                              <vue-json-pretty
                                :data="prop.value"
                              ></vue-json-pretty>
                            </v-col>
                            <v-col class="text-right">
                              <property-dialog
                                @reload="reload"
                                :id="device.id"
                                :prop="prop"
                              ></property-dialog>
                            </v-col>
                          </v-row>
                        </v-card>
                      </template>
                      <template v-else>
                        <v-text-field readonly solo v-model="prop.value">
                          <property-dialog
                            @reload="reload"
                            :id="device.id"
                            :prop="prop"
                            slot="append"
                          ></property-dialog>
                        </v-text-field>
                      </template>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DataHome.devices.map")
              }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item>
            <v-list-item-content>
              <template v-if="propertyloading">
                <div class="text-center mb-5">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
              </template>
              <template v-else>
                <v-col v-if="latProperty == null" cols="11">
                  <v-alert type="warning">{{
                    $t("DataHome.noLatProperty")
                  }}</v-alert>
                </v-col>
                <v-col v-if="longProperty == null" cols="11">
                  <v-alert type="warning">{{
                    $t("DataHome.noLongProperty")
                  }}</v-alert>
                </v-col>
                <v-col v-if="latProperty != null" cols="12" sm="7">
                  <div
                    class="text-subtitle-2 mb-2"
                    v-text="latProperty.property"
                  ></div>
                  <v-text-field readonly solo v-model="latProperty.value">
                    <property-dialog
                      @reload="reload"
                      :id="device.id"
                      :prop="latProperty"
                      slot="append"
                    ></property-dialog>
                  </v-text-field>
                </v-col>
                <v-col v-if="longProperty != null" cols="12" sm="7">
                  <div
                    class="text-subtitle-2 mb-2"
                    v-text="longProperty.property"
                  ></div>
                  <v-text-field readonly solo v-model="longProperty.value">
                    <property-dialog
                      @reload="reload"
                      :id="device.id"
                      :prop="longProperty"
                      slot="append"
                    ></property-dialog>
                  </v-text-field>
                </v-col>
                <map-comp
                  v-if="longProperty != null && latProperty != null"
                  :markerLatLng="[
                    [Number(latProperty.value), Number(longProperty.value)],
                  ]"
                  :toCenterLatLong="[
                    Number(latProperty.value),
                    Number(longProperty.value),
                  ]"
                  :center="[
                    Number(latProperty.value),
                    Number(longProperty.value),
                  ]"
                  :mapheight="'500px'"
                  :mapwitdh="'93%'"
                  :recenter="recenter"
                  @recenter="recenter = !recenter"
                ></map-comp>
              </template>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group sub-group no-action :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DataHome.Device-Connector")
              }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <template>
            <v-list-item>
              <v-container>
                <v-row justify="space-around" align="center">
                  <v-col cols="12" sm="6">
                    <v-row align="center">
                      <v-col class="text-right">
                        <v-jsoneditor
                          style="z-index: 1"
                          v-model="testJson"
                          :plus="false"
                          :options="{ mode: 'code', enableTransform: false }"
                          :height="'250px'"
                        ></v-jsoneditor>
                      </v-col>
                      <v-col class="text-left">
                        <p>TestJson :</p>
                        <vue-json-pretty :data="testJson"></vue-json-pretty>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <codeInput
                  v-if="codeReady"
                  :code="code"
                  @newCode="newCode"
                ></codeInput>
                <v-row>
                  <v-col class="text-center">
                    <v-btn
                      class="ma-2"
                      tile
                      outlined
                      color="primary"
                      @click="deleteConnector"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      {{ $t("DeviceTypes.delete") }}
                    </v-btn>
                  </v-col>
                  <v-col class="text-center">
                    <v-btn
                      class="ma-2"
                      tile
                      outlined
                      color="primary"
                      @click="saveConnector"
                    >
                      <v-icon left>mdi-arrow-left</v-icon>
                      {{ $t("DeviceTypes.save") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-list-item>
          </template>
        </v-list-group>
        <v-list-group sub-group no-action :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DataHome.devices.deviceAlert")
              }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <template>
            <v-list-item>
              <v-list-item-content class="pa-5">
                <v-card>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{ $t("DeviceTypes.name") }}
                          </th>
                          <th class="text-left">
                            {{ $t("DataHome.trigger") }}
                          </th>
                          <th>
                            <v-btn icon @click="createAlert()">
                              <v-icon>add</v-icon>
                            </v-btn>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(alert, index) in alerts" :key="index">
                          <td>{{ alert.name }}</td>
                          <td>{{ alert.fields }}</td>
                          <td>
                            <v-btn
                              icon
                              :id="index"
                              @click="updateAlert($event)"
                            >
                              <v-icon :id="index">settings</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>

        <v-list-group sub-group no-action :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("DataHome.devices.lastdata")
              }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-if="loading">
            <div class="text-center mb-5">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </template>
          <template v-else>
            <v-list-item>
              <v-list-item-content>
                <vue-json-pretty :data="lastData"></vue-json-pretty>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>

        <v-list-group sub-group no-action :value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-row align="center" justify="space-between">
                <v-col cols="12" sm="3" md="1" class="text-left">
                  <v-list-item-title>{{
                    $t("DataHome.devices.data")
                  }}</v-list-item-title>
                </v-col>
                <v-col @click.stop cols="12" md="3" sm="3">
                  <div class="text-subtitle-2" v-text="'Channel'"></div>
                  <v-text-field
                    :placeholder="$t('Admin.enterFilter')"
                    solo
                    v-model="filterChannel"
                  ></v-text-field>
                </v-col>
                <template v-if="filterDate">
                  <v-col cols="12" sm="2" md="1" class="text-right">{{
                    $t("DataHome.from")
                  }}</v-col>
                  <v-col cols="12" sm="9" md="3" class="mr-2">
                    <v-text-field
                      @click.stop
                      :hide-details="true"
                      label="To"
                      v-model="minFormatedDate"
                      readonly
                      solo
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="2" md="1" class="text-right">{{
                    $t("DataHome.to")
                  }}</v-col>
                  <v-col cols="12" sm="9" md="3" class="mr-2">
                    <v-text-field
                      @click.stop
                      :hide-details="true"
                      label="To"
                      v-model="maxFormatedDate"
                      readonly
                      solo
                    ></v-text-field>
                  </v-col>
                </template>
                <v-col cols="12" sm="12" md="2" class="text-center">
                  <filter-dialog
                    :quantity="quantity"
                    :filterDate="filterDate"
                    :checkbox="decreaseDate"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    @filter="setFilter"
                  ></filter-dialog>
                </v-col>
              </v-row>
            </v-list-item-content>
          </template>
          <template v-if="loading">
            <div class="text-center mb-5">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </template>
          <template v-else>
            <template v-if="data != undefined && data.length > 0">
              <template v-for="(data, i) in data">
                <v-list-group :key="i" sub-group :value="false">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="showDate(new Date(data.time))"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item>
                    <v-list-item-content>
                      <div v-if="data.channel != null" class="mb-3">
                        Channel : {{ data.channel }}
                      </div>

                      <vue-json-pretty :data="data.data"></vue-json-pretty>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </template>
            </template>
            <template v-else>
              <v-container>
                <v-alert type="warning" class="ma-5">{{
                  $t("DataHome.alert-nodata")
                }}</v-alert>
              </v-container>
            </template>
          </template>
        </v-list-group>
      </v-list>
    </v-card>
    <buttons @back="$emit('backnetwork')"></buttons>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

import CodeInputComponent from "../DeviceTypes/CodeInput";
import VJsoneditor from "v-jsoneditor/src/index";
import VueJsonPretty from "vue-json-pretty";
import MapComponent from "../Map/Map";

import ButtonsComponent from "./Buttons";
import FilterComponent from "./FilterDialog";
import PropertyDialog from "./PropertyDialog";

export default {
  components: {
    buttons: ButtonsComponent,
    VJsoneditor,
    VueJsonPretty,
    codeInput: CodeInputComponent,
    "filter-dialog": FilterComponent,
    "property-dialog": PropertyDialog,
    "map-comp": MapComponent,
  },
  data: () => ({
    dataObject: {},
    interval: null,
    quantity: 10,
    decreaseDate: true,
    filterDate: false,
    minDate: new Date().setHours(2, 0, 0),
    maxDate: new Date().setHours(12, 0, 0),
    queryDataObject: {},
    loading: true,
    propertyloading: true,
    properties: [],
    latProperty: null,
    longProperty: null,
    recenter: false,
    alerts: [],
    testJson: {},
    code: "",
    codeReady: false,
    alertMsg: "",
    alertShow: false,
    alertType: "error",
    filterChannel: "",
  }),
  props: {
    device: Object,
  },
  computed: {
    readyToSave: function () {
      if (
        !(
          Object.keys(this.testJson).length === 0 &&
          this.testJson.constructor === Object
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    query: function () {
      if (!this.filterDate) {
        return (
          process.env.VUE_APP_API_ADDR +
          "/api/device/" +
          this.device.id +
          "/data"
        );
      } else {
        return (
          process.env.VUE_APP_API_ADDR +
          "/api/device/" +
          this.device.id +
          "/data/query?minDate=" +
          this.minDate +
          "&maxDate=" +
          this.maxDate
        );
      }
    },
    maxFormatedDate: function () {
      return this.showDate(new Date(this.maxDate));
    },
    minFormatedDate: function () {
      return this.showDate(new Date(this.minDate));
    },
    lastData: function () {
      console.log(this.dataObject);
      let lastData = this.dataObject.lastData;
      try {
        lastData.data = JSON.parse(lastData.data);
      } catch (e) {
        //
      }
      return lastData;
    },
    data: function () {
      let array;
      if (this.filterDate) {
        array = this.queryDataObject.data;
      } else {
        array = this.dataObject.data;
      }
      function compare(d1, d2) {
        let a = new Date(d1.date);
        let b = new Date(d2.date);
        return isFinite(a) && isFinite(b) ? (a > b) - (a < b) : NaN;
      }
      if (array != undefined) {
        let tmpArray = [];
        array.forEach((data) => {
          if (data.channel != null) {
            if (this.filterChannel != undefined) {
              if (
                data.channel
                  .toLowerCase()
                  .startsWith(this.filterChannel.toLowerCase())
              ) {
                try {
                  data.data = JSON.parse(data.data);
                  tmpArray.push(data);
                } catch (e) {
                  //
                  tmpArray.push(data);
                }
              }
            } else {
              try {
                data.data = JSON.parse(data.data);
                tmpArray.push(data);
              } catch (e) {
                //
                tmpArray.push(data);
              }
            }
          } else {
            try {
              data.data = JSON.parse(data.data);
              tmpArray.push(data);
            } catch (e) {
              //
              tmpArray.push(data);
            }
          }
        });
        if (this.decreaseDate) {
          return tmpArray.sort(compare).slice(0, this.quantity);
        } else {
          return tmpArray.sort(compare).reverse().slice(0, this.quantity);
        }
      } else {
        return array;
      }
    },
  },
  watch: {
    data: function () {
      this.loading = false;
    },
  },
  methods: {
    reloadConnector() {
      axios
        .get(
          process.env.VUE_APP_API_ADDR +
            "/api/device/" +
            this.device.id +
            "/connector",
          {
            headers: { Authorization: tokenStore.getToken() },
          }
        )
        .then((res) => {
          this.codeReady = false;
          if (res.data.success) {
            this.code = res.data.device.connector;
            setTimeout(() => {
              this.codeReady = true;
              window.scrollTo(0, 0);
            }, 1);
          }
        })
        .catch((err) => {
          console.log(err);
          this.alertType = "error";
          this.alertMsg = err.response.data.errorMessage;
          this.alertShow = true;
          window.scrollTo(0, 0);
        });
    },
    saveConnector: function () {
      if (this.readyToSave) {
        axios
          .post(
            process.env.VUE_APP_API_ADDR +
              "/api/device/" +
              this.device.id +
              "/connector",
            {
              connector: this.code,
              testJson: this.testJson,
            },
            {
              headers: { Authorization: tokenStore.getToken() },
            }
          )
          .then(() => {
            this.reloadConnector();
            this.alertType = "success";
            this.alertMsg = "Device connector successfully updated";
            this.alertShow = true;
          })
          .catch((err) => {
            this.alertType = "error";
            this.alertMsg = err.response.data.errorMessage;
            this.alertShow = true;
            window.scrollTo(0, 0);
          });
      } else {
        this.alertType = "error";
        this.alertMsg = "Complete correctly connector form !";
        this.alertShow = true;
        window.scrollTo(0, 0);
      }
    },
    deleteConnector() {
      axios
        .delete(
          process.env.VUE_APP_API_ADDR +
            "/api/device/" +
            this.device.id +
            "/connector",
          {
            headers: { Authorization: tokenStore.getToken() },
          }
        )
        .then(() => {
          this.reloadConnector();
          this.alertType = "success";
          this.alertMsg = "Device connector successfully removed";
          this.alertShow = true;
        })
        .catch((err) => {
          this.alertType = "error";
          this.alertMsg = err.response.data.errorMessage;
          this.alertShow = true;
          window.scrollTo(0, 0);
        });
    },
    newCode(value) {
      this.code = value;
    },
    createAlert: function () {
      this.$emit("createAlert");
    },
    updateAlert: function (event) {
      if (event.target.id != "") {
        this.$emit("updateAlert", this.alerts[event.target.id]);
      }
    },
    showDate(date) {
      return date.toLocaleString(this.$t("DataHome.dateformat"));
    },
    setFilter(value) {
      this.quantity = value.quantity;
      this.decreaseDate = value.checkbox;
      this.filterDate = value.filterDate;
      this.minDate = value.minDate;
      this.maxDate = value.maxDate;
      axios
        .get(this.query, {
          headers: { Authorization: tokenStore.getToken() },
        })
        .then((res) => {
          if (this.filterDate) {
            this.queryDataObject = res.data;
          } else {
            this.dataObject = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reload: function () {
      axios
        .get(
          process.env.VUE_APP_API_ADDR +
            "/api/device/" +
            this.device.id +
            "/deviceTypeProperty",
          {
            headers: { Authorization: tokenStore.getToken() },
          }
        )
        .then((res) => {
          this.properties = [];
          res.data.device.deviceTypeProperty.forEach((prop) => {
            if (prop.property == "long") {
              this.longProperty = prop;
            } else if (prop.property == "lat") {
              this.latProperty = prop;
            } else {
              this.properties.push(prop);
            }
          });
          this.propertyloading = false;
          this.recenter = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount: function () {
    this.reloadConnector();
    axios
      .get(
        process.env.VUE_APP_API_ADDR +
          "/api/device/" +
          this.device.id +
          "/deviceAlert",
        {
          headers: { Authorization: tokenStore.getToken() },
        }
      )
      .then((res) => {
        if (res.data.success) {
          this.alerts = res.data.device.deviceAlert;
          this.alerts.forEach((alert) => {
            alert.fields = [];
            Object.keys(alert.testJson).forEach((field) => {
              alert.fields.push(field);
            });
          });
        }
      })
      .catch(() => {
        this.alertType = "error";
        this.alertMsg = this.$t("DeviceTypes.Alert.error");
        this.alert = true;
      });
    axios
      .get(
        process.env.VUE_APP_API_ADDR +
          "/api/device/" +
          this.device.id +
          "/deviceTypeProperty",
        {
          headers: { Authorization: tokenStore.getToken() },
        }
      )
      .then((res) => {
        res.data.device.deviceTypeProperty.forEach((prop) => {
          if (prop.property == "long") {
            this.longProperty = prop;
          } else if (prop.property == "lat") {
            this.latProperty = prop;
          } else {
            this.properties.push(prop);
          }
        });
        this.propertyloading = false;
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(
        process.env.VUE_APP_API_ADDR +
          "/api/device/" +
          this.device.id +
          "/data",
        {
          headers: { Authorization: tokenStore.getToken() },
        }
      )
      .then((res) => {
        console.log(res.data);
        if (this.filterDate) {
          this.queryDataObject = res.data;
        } else {
          this.dataObject = res.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted: function () {
    window.scrollTo(0, 0);
    this.interval = setInterval(() => {
      axios
        .get(this.query, {
          headers: { Authorization: tokenStore.getToken() },
        })
        .then((res) => {
          if (this.filterDate) {
            this.queryDataObject = res.data;
          } else {
            this.dataObject = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, 3000);
  },
  beforeDestroy: function () {
    clearInterval(this.interval);
  },
};
</script>
